module.exports = __webpack_public_path__ + "img/constant-house.b1f61a0a.png";